import firebase from 'firebase';
let AuthFactory = function($firebaseAuth) {
  "ngInject";
  const user = {};
  let ref = firebase.database().ref();
  let Auth = $firebaseAuth(firebase.auth());

  return Auth;
};

export default AuthFactory;



// WEBPACK FOOTER //
// ./client/app/components/auth/auth.factory.js